<template>
  <div class="tw-mb-1 tw-flex tw-items-center tw-justify-between tw-text-xs dark:tw-text-white">
    <label v-if="label" :for="htmlFor">
      {{ label }}
    </label>
    <span v-if="lengthCounter" class="tw-ml-auto tw-text-slate-400">
      {{ lengthCounter }}
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioLabel',
  props: {
    label: {
      type: String,
      default: ''
    },
    lengthCounter: {
      type: String,
      default: ''
    },
    htmlFor: {
      type: String,
      default: ''
    }
  }
});
</script>
